<template>
  <div style="width: 100%">
    <div class="mr-4">
      <!-- Filtros do Cadastro (Unidades, Deficiente, Deficiência) -->
      <v-row>
        <v-col>
          <filtro-cadastro
            @return="(value) => (filtros.filtroCadastro = value)"
          />
        </v-col>
      </v-row>

      <!-- Filtros do Formação (Cursos, Idiomas, Instrutor de Capacitação, etc) -->
      <v-row>
        <v-col>
          <filtro-formacao
            @formacaoAcademica="
              (value) => (filtros.filtroFormacaoAcademica = value)
            "
            @formacaoComplementar="
              (value) => (filtros.filtroFormacaoComplementar = value)
            "
          />
        </v-col>
      </v-row>

      <!-- Filtros do Cadastro (Unidades, Deficiência) -->
      <v-row>
        <v-col>
          <filtro-atuacao-profissional
            @return="(value) => (filtros.filtroAtuacaoProfissional = value)"
          />
        </v-col>
      </v-row>

      <!-- Atividades de Interesse (Atividade de Cultura e Arte e Atividades de Esporte) -->
      <v-row>
        <v-col>
          <filtro-atividade-interesse
            @return="(value) => (filtros.filtroAtividadeInteresse = value)"
          />
        </v-col>
      </v-row>

      <!-- Preferências de Trabalho -->
      <v-row>
        <v-col>
          <filtro-preferencia-trabalho
            @return="(value) => (filtros.filtroPreferenciaTrabalho = value)"
          />
        </v-col>
      </v-row>

      <!-- Resultados dos Filtros -->
      <div class="ml-2">
        <!-- Resumos dos Filtros -->
        <v-row
          v-if="resumos.length > 0"
          dense
        >
          <v-col>
            <resumo-filtro-busca :value="resumos" />
          </v-col>
        </v-row>

        <!-- tabela com resultados -->
        <v-row v-show="pesuisaInicial">
          <v-col>
            <resultado-filtro-busca :perfis="perfis" />
          </v-col>
        </v-row>
      </div>

      <!-- Botões de Ação -->
      <v-row
        class="justify-end mx-1 my-4"
        dense
      >
        <!-- Pesquisar -->
        <v-tooltip top>
          <template v-slot:activator="{ on: onTooltip }">
            <v-btn
              color="primary"
              @click="pesquisar"
              v-on="{ ...onTooltip }"
            >
              Pesquisar
            </v-btn>
          </template>
          <span>Clique para pesquisar</span>
        </v-tooltip>

        <!-- Relatório PDF -->
        <v-tooltip
          v-if="perfis.length > 0"
          max-width="400"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              class="ml-2"
              @click="getRelatorio()"
              v-on="on"
            >
              <v-icon>get_app</v-icon>
              BAIXAR PDF
            </v-btn>
          </template>
          <span>Clique para baixar o relatório dos dados em formato PDF.</span>
        </v-tooltip>
      </v-row>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { generatePDF } from '@/modules/relatorioPDF';
import FiltroCadastro from '@/components/monitoramento/perfil/filtro/FiltroCadastro';
import FiltroFormacao from '@/components/monitoramento/perfil/filtro/FiltroFormacao';
import FiltroAtuacaoProfissional from '@/components/monitoramento/perfil/filtro/FiltroAtuacaoProfissional';
import FiltroAtividadeInteresse from '@/components/monitoramento/perfil/filtro/FiltroAtividadeInteresse';
import FiltroPreferenciaTrabalho from '@/components/monitoramento/perfil/filtro/FiltroPreferenciaTrabalho';
import ResumoFiltroBusca from '@/components/monitoramento/perfil/filtro/ResumoFiltroBusca';
import ResultadoFiltroBusca from '@/components/monitoramento/perfil/filtro/ResultadoFiltroBusca';

const perfilRepository = RepositoryFactory.get('perfil');

export default {
  name: 'FiltroBuscaPerfil',

  components: {
    FiltroCadastro,
    FiltroFormacao,
    FiltroAtuacaoProfissional,
    ResumoFiltroBusca,
    FiltroAtividadeInteresse,
    FiltroPreferenciaTrabalho,
    ResultadoFiltroBusca,
  },

  data() {
    return {
      filtros: {
        filtroCadastro: null,
        filtroFormacaoAcademica: null,
        filtroFormacaoComplementar: null,
        filtroAtuacaoProfissional: null,
        filtroAtividadeInteresse: null,
        filtroPreferenciaTrabalho: null,
      },
      perfis: [],
      resumos: [],
      pesuisaInicial: false,
    };
  },

  methods: {
    pesquisar() {
      this.resumos = this.getResumos();
      this.setDefault();
      if (this.filtros.filtroCadastro && this.filtros.filtroCadastro.unidades.habilitado) {
        perfilRepository.buscar(this.filtros).then((res) => {
          this.pesuisaInicial = true;
          this.perfis = res.data;
          this.$store.dispatch('app/success', { response: res, message: '' });
        });
      } else {
        this.$store.dispatch('app/showMessage', {
          cor: 'warning',
          texto: 'É necessário selecionar, pelo menos, uma unidade!',
        });
      }
    },
    getResumos() {
      const resumos = [
        { titulo: 'CADASTRO', ...this.getResumoFiltro(this.filtros.filtroCadastro) },
        {
          titulo: 'FORMAÇÃO',
          ...this.getResumoFiltro({
            ...this.filtros.filtroFormacaoAcademica,
            ...this.filtros.filtroFormacaoComplementar,
          }),
        },
        { titulo: 'ATUAÇÃO PROFISSIONAL', ...this.getResumoFiltro(this.filtros.filtroAtuacaoProfissional) },
        { titulo: 'ATIVIDADES DE INTERESSE', ...this.getResumoFiltro(this.filtros.filtroAtividadeInteresse) },
        {
          titulo: 'PREFERÊNCIAS DE TRABALHO',
          ...this.getResumoFiltro(
            this.filtros.filtroPreferenciaTrabalho ? this.filtros.filtroPreferenciaTrabalho.lista : null,
          ),
        },
      ];
      return resumos.filter((r) => r.habilitado);
    },
    getResumoFiltro(filtro) {
      const copy = { ...filtro };
      delete copy.habilitado;
      return {
        ...copy,
        headers: this.getHeaders(copy),
        habilitado: this.getHabilitado(copy),
      };
    },
    getHeaders(filtro) {
      const headers = [];
      if (filtro) {
        Object.keys(filtro).forEach((prop) => {
          if (filtro[prop].habilitado) {
            const header = {
              text: filtro[prop].tituloVisualizacao.toUpperCase(),
              value: `${prop}.visualizacao`,
              sortable: false,
              align: 'left',
            };
            headers.push(header);
          }
        });
      }
      return headers;
    },
    getHabilitado(filtro) {
      return filtro
        ? Object.keys(filtro).reduce((acumulador, prop) => {
          if (filtro[prop].habilitado) {
            acumulador = true;
          }
          return acumulador;
        }, false)
        : false;
    },
    setDefault() {
      this.perfis = [];
      this.pesuisaInicial = false;
    },
    async getRelatorio() {
      const documento = {
        nome: 'relatorio-filtros-busca-perfil',
        cabecalho: {
          titulo: 'Relatório de Filtros de Busca do Perfil',
          itens: [
            '',
          ],
        },
        blocos: [
          {
            titulo: 'RESUMOS',
            subtitulo: 'FILTROS',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: ['FILTROS SELECIONADOS'],
                linhas: this.resumos.map((r) => {
                  const selecionado = Object.keys(r)
                    .filter((prop) => r[prop].habilitado)
                    .map((prop) => ` [${r[prop].tituloVisualizacao.toUpperCase()}]: ${r[prop].visualizacao}`);

                  return [r.titulo.concat('\n\n', selecionado)];
                }),
              },
            }],
          },
          {
            titulo: 'RESULTADOS',
            subtitulo: 'PERFIS',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  'SERVIDOR',
                  'SIAPE',
                  'UNIDADE',
                  'CARGO',
                  'CATEGORIA',
                ],
                linhas: this.perfis.map((p) => ([
                  p.nome,
                  p.siape,
                  p.unidadeSigla,
                  p.cargo,
                  p.categoria,
                ])),
              },
            }],
          },
        ],
      };
      generatePDF(documento);
    },
  },
};
</script>
